import { internal } from '../../vendor/elix.js';

function FormValueMixin(Base) {
  return class FormValueMixin extends Base {

    connectedCallback() {
      super.connectedCallback();
      this.updateFormValue();
    }

    [internal.render](changed) {
      super[internal.render](changed);
      this.updateFormValue();
    }

    updateFormValue() {
      if (this[internal.nativeInternals] && this[internal.nativeInternals].setFormValue) {
        this[internal.nativeInternals].setFormValue(this.value, this[internal.state]);
      }
    }

  }
}

export default FormValueMixin;
